const paths = {
  home: '/pocetna',
  articleBlog: `/vesti`,
  article: `/vesti/:id`,
  aboutUs: `/o-nama`,
  contact: `/kontakt`,
};

export default paths;
